import * as React from 'react'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { safeBoolean } from '../../utils/utils'
import * as st from './ad.module.scss'
import { LocalizerProps, withLocalization } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'

export interface AdBadgeProps {
  isAd?: boolean
}

type LocalizedAdProps = AdBadgeProps & LocalizerProps
export const AdWithLocalization = ({ isAd, getString }: LocalizedAdProps) => (
  safeBoolean(isAd) &&
  (<span data-automation-id="ad-badge" className={st.adLogo} title={getString(StringId.DV_DP_ARIA_audio_description)}
         aria-label={getString(StringId.DV_DP_ARIA_audio_description)}>
    <Icon use={IconType.AUDIO_DESCRIPTION} />
  </span>) || null
)

export const Ad = withLocalization(AdWithLocalization)
